export default __webpack_public_path__ + "static/media/certification_white.80b23b39.svg";